export const serviceKind = (service) => {
  const name = service.name.toLocaleLowerCase('da-DK').replace(/\s+/g, '');
  if (name === 'hjulskifte') return 'wheel';
  if (name.includes('serviceeftersyn')) return 'service';
  if (name.includes('fejlsøgning')) return 'diagnostics';
  return null;
};

export const isWheelChange = (service) => serviceKind(service) === 'wheel';
export const formatPrice = (price) => `${Number(price).toLocaleString('da-DK', { maximumFractionDigits: 2 })} kr`;
const presentation = {
  wheel: { title: 'Hjulskifte', description: 'Vi skifter mellem sommer- og vinterhjul hjemme hos dig eller på arbejdet.', action: 'Book hjulskifte' },
  service: { title: 'Serviceeftersyn', description: 'Service efter fabrikkens forskrifter, så din elbil og fabriksgaranti er godt passet.', action: 'Book serviceeftersyn' },
  diagnostics: { title: 'Fejlsøgning', description: 'Få udlæst fejlkoder og hjælp til at finde årsagen til bilens advarsler.', action: 'Book fejlsøgning' },
};
export const presentService = (service) => presentation[serviceKind(service)] || {
  title: service.name, description: service.description, action: `Book ${service.name.toLocaleLowerCase('da-DK')}`,
};